export * from './series.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/index.ts